import errorPagesConfig from './error/errorPagesConfig';
import paymentPagesConfig from './payments/paymnetPagesConfig';

const pagesConfigs = [
  errorPagesConfig,
  paymentPagesConfig,
];

export default pagesConfigs;
